import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface CustomerTypeParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface CustomerType {
    id?: any;
   
    customerTypeName:string;
    
    
    parameters?: CustomerTypeParameter[];
    links?: any;
}


export abstract class CustomerTypeData {
    
    abstract list(url: string): Observable<CustomerType[]>;
    abstract create(url: string, data: CustomerType): Observable<CustomerType[]>;
    abstract update(url: string, data: CustomerType): Observable<CustomerType>;
    abstract delete(url: string): Observable<any>;
}
